
import { useNavigate, useParams } from "react-router-dom";
import baguette from "../../assets/images/photos/baguette.jpg";
import avatar1 from "../../assets/images/photos/Blog1.jpg";
import avatar2 from "../../assets/images/photos/Blog2.jpg";
import avatar3 from "../../assets/images/photos/Blog3.jpg";
import molde from "../../assets/images/photos/molde.jpeg";
import trigo from "../../assets/images/photos/trigo.jpeg";
import { Container } from "../../components/atoms/Container";
import { Prose } from '../../components/atoms/Prose';
import { formatDate } from "../../utils/formatDate";
import { IIcon } from "./BlogLayout";
import { Header } from "../../components/atoms/Header";

const meta =
    [
        {
            author: 'Juan Marin',
            avatar: avatar1,
            date: '2022-09-05',
            title: 'Pan de molde',
            img: molde,
            description: (<p>El pan de molde es una opción que nunca falla. Con su corteza crujiente y su interior suave
                y tierno, es una elección perfecta para el desayuno, el almuerzo y la cena. Además, es una
                alternativa versátil que se puede consumir en una amplia variedad de formas, desde tostadas hasta sandwichs y bocadillos.<br/><br/>
                El pan de molde ha sido un ingrediente clave en la dieta de la mayoría de las personas por
                siglos. Con su fácil accesibilidad y su bajo costo, es una opción popular para aquellos que
                buscan una comida rápida y satisfactoria. Pero, a pesar de su popularidad, muchas personas desconocen la historia y el proceso detrás de la elaboración de este pan.
                El pan de molde se hace a partir de una mezcla de harina, agua, levadura y sal. La masa se
                amasa y se deja levar antes de ser moldeada y horneada. La forma y el tamaño del pan de
                molde dependen del tipo de corteza que se desea, desde una corteza suave hasta una
                corteza crujiente.<br/><br/>
                Además de su versatilidad y accesibilidad, el pan de molde también es una opción saludable. Es una fuente de carbohidratos complejos que proporcionan energía a largo plazo, así
                como de proteínas y vitaminas B. Sin embargo, es importante tener en cuenta que no todos
                los tipos de pan de molde son iguales en cuanto a su contenido nutricional. Algunos tipos
                pueden ser más altos en sodio y azúcares añadidos, por lo que es importante leer las
                etiquetas y elegir opciones más saludables.<br/><br/>
                En resumen, el pan de molde es una opción popular y versátil que ofrece una amplia variedad de opciones para el desayuno, el almuerzo y la cena. Con su historia y proceso de
                elaboración, así como sus beneficubrimientos nutricionales, es un ingrediente clave en la
                dieta de muchas personas en todo el mundo.</p>)
        },
        {
            author: 'Julio Alvarez',
            avatar: avatar2,
            date: '2022-09-05',
            title: 'El pan hamburguesa',
            img: trigo,
            description: (<p>El pan hamburguesa: Un ingrediente clave para el éxito de cualquier comida rápida
                El pan hamburguesa es un elemento clave en cualquier comida rápida. No solo es un ingrediente versátil que se puede adaptar a cualquier sabor y textura, sino que también es un
                elemento esencial para el equilibrio y la consistencia de una hamburguesa.<br/><br/>
                Hay una amplia variedad de tipos de pan hamburguesa disponibles en el mercado, desde
                pan blanco hasta pan integral, y cada uno de ellos tiene sus propias características únicas.
                El pan blanco suave es una opción popular para aquellos que buscan un sabor dulce y
                suave, mientras que el pan integral es una opción más saludable y nutricional para aquellos
                que buscan algo un poco más ligero.<br/><br/>
                Además, el pan hamburguesa no solo es un ingrediente importante para las hamburguesas,
                sino que también es un ingrediente versátil para otros platos. Se puede usar para hacer un
                sándwich clásico, un pan de ajo, o incluso una base para una pizza.<br/><br/>
                Sin embargo, no todos los panes hamburguesa son iguales. Es importante elegir un pan de
                alta calidad para asegurarse de que su hamburguesa o plato tenga el sabor y la textura
                adecuados. Un pan fresco y suave es esencial para que la carne y los aderezos se complementen de manera adecuada.<br/><br/>
                En conclusión, el pan hamburguesa es un ingrediente clave para cualquier comida rápida.
                Desde la elección del tipo de pan hasta la frescura y calidad, es importante tener en cuenta
                estos factores para asegurarse de que su hamburguesa o plato sea un éxito. ¡Así que la
                próxima vez que hagas una hamburguesa, asegúrate de elegir el pan adecuado!</p>),
        },
        {
            author: 'Gretel Otero',
            avatar: avatar3,
            date: '2022-09-05',
            title: '"El pan Baguette: Un clásico de la panadería francesa"',
            img: baguette,
            description:
                (<p>El pan Baguette es uno de los tipos de pan más reconocidos y apreciados en todo el
                    mundo. Con su forma característica y su corteza crujiente, este pan se ha convertido en un
                    clásico de la panadería francesa y es un elemento esencial en la cocina gourmet.<br/><br/>
                    El pan Baguette se originó en Francia en el siglo XVIII y se ha vuelto muy popular en todo el
                    mundo desde entonces. Se caracteriza por su forma alargada y su corteza dorada y crujiente, que lo hace ideal para ser cortado y rellenado con una amplia variedad de ingredientes.
                    Es un pan versátil que se puede comer solo o utilizar como base para una amplia variedad
                    de platos, como sandwiches, bruschettas o crostini.<br/><br/>
                    El pan Baguette se hace con una mezcla de harina, agua, sal y levadura. La clave para conseguir su textura única es un proceso de fermentación prolongado, que permite que el pan
                    desarrolle su sabor y aroma característicos. La corteza del pan Baguette es resultado de un
                    proceso de horneado a alta temperatura, lo que le da su textura crujiente y su sabor tostado.
                    Además de su sabor y textura, el pan Baguette también es conocido por su versatilidad en
                    la cocina. Se puede utilizar como base para una amplia variedad de platos, desde sandwiches hasta bruschettas y crostini. También se puede cortar en rodajas finas y tostar para
                    acompañar salsas y aperitivos.<br/><br/>
                    En resumen, el pan Baguette es un clásico de la panadería francesa que ha ganado una gran
                    popularidad en todo el mundo. Con su forma alargada, su corteza crujiente y su sabor único,
                    es un pan versátil y delicioso que se ha convertido en un elemento esencial en la cocina
                    gourmet. ¡Prueba un trozo de pan Baguette hoy mismo y descubre por qué es uno de los
                    panes más populares del mundo!</p>),
        }
    ]

const previousPathname = "/";


function ArrowLeftIcon(props: IIcon) {

    return (
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true" className={props.className}>
            <path
                d="M7.25 11.25 3.75 8m0 0 3.5-3.25M3.75 8h8.5"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export function BlogDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const index = Number(id);

    return (
        <>
            <Header />
            <Container className="mt-16 lg:mt-32">
                <div className="xl:relative">
                    <div className="mx-auto max-w-2xl">
                        {previousPathname && (
                            <button
                                type="button"
                                onClick={() => navigate(-1)}
                                aria-label="Go back to articles"
                                className="group mb-8 flex h-10 w-10 items-center justify-center rounded-full bg-white shadow-md shadow-zinc-800/5 ring-1 ring-zinc-900/5 transition dark:border dark:border-zinc-700/50 dark:bg-zinc-800 dark:ring-0 dark:ring-white/10 dark:hover:border-zinc-700 dark:hover:ring-white/20 lg:absolute lg:-left-5 lg:mb-0 lg:-mt-2 xl:-top-1.5 xl:left-0 xl:mt-0"
                            >
                                <ArrowLeftIcon className="h-4 w-4 stroke-zinc-500 transition group-hover:stroke-zinc-700 dark:stroke-zinc-500 dark:group-hover:stroke-zinc-400" />
                            </button>
                        )}
                        <article>
                            <header className="flex flex-col">
                                <h1 className="mt-6 text-4xl font-bold tracking-tight text-zinc-800 dark:text-zinc-100 sm:text-5xl">
                                    {meta[index - 1].title}
                                </h1>
                                <time
                                    dateTime={meta[index - 1].date}
                                    className="order-first flex items-center justify-between text-base text-zinc-400 dark:text-zinc-500"
                                >
                                    <div className="order-first flex items-center">
                                        <span className="h-4 w-0.5 rounded-full bg-gray-900 dark:bg-white" />
                                        <span className="ml-3 dark:text-white text-gray-900">{formatDate(meta[index - 1].date)}</span>

                                    </div>
                                    <div className="flex-shrink-0">
                                        <div className="flex items-center gap-2">
                                            <img className="h-10 w-10 rounded-full" src={meta[index - 1].avatar} alt="" />
                                            <span className="dark:text-white text-gray-900">{meta[index-1].author}</span>
                                        </div>
                                    </div>
                                </time>
                            </header>
                            <img className="mt-8 rounded-4xl" src={meta[index - 1].img} alt="" />
                            <Prose className="mt-8 dark:text-white text-gray-900">{meta[index - 1].description}</Prose>
                        </article>
                    </div>
                </div>
            </Container>
        </>
    );
}